
export const SalesCardWrapper = ({ children, componentStyles, componentClassname }) => {
    return <>

        <div
            className={`px-3 pt-3 pb-2 ${componentClassname}`}
            style={{
                boxShadow: "0px 4px 3px 0px rgba(126, 126, 126, 0.1)",
                border: "1px solid #efefef",
                borderRadius: "0.625rem",
                backgroundColor: "#fff",
                ...componentStyles
            }}
        >
            {children}
        </div>
    </>
}